import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { withNamespaces } from 'react-i18next';
import { MenuOption } from 'legacyComponents/layout/menuOption';
import { OptionFieldStore } from 'libs/forms/fieldStores';

@withNamespaces()
@observer
export class OptionField extends React.Component {
  static defaultStore = OptionFieldStore;
  selectOption = e => {
    this.props.optionHandler(e.currentTarget.id);
  };

  render() {
    const { t } = this.props;
    const options = [];
    const { conf } = this.props.fieldStore;
    // FIXME - replace with map
    // eslint-disable-next-line
    for (const opt in conf.options) {
      const option = conf.options[opt];

      options.push(
        <MenuOption
          linkName={option.link}
          id={option.goTo}
          title={t(option.label)}
          icon={option.icon}
          shortcut={option.shortcut}
          description={option.description && t(option.description)}
          onclick={option.link ? () => {} : this.selectOption}
          key={option.label}
        />,
      );
    }
    return <Wrapper>{options}</Wrapper>;
  }
}

const Wrapper = styled.div`
  margin: 15px 0px 0px 0px;
`;

OptionField.propTypes = {
  fieldStore: PropTypes.object,
  optionHandler: PropTypes.func,
  t: PropTypes.func,
};
